import { ChatMsgVM } from './message.types';

/**
 * SD-2765: the prompt a bot bubble is answering — the nearest user message above it.
 *
 * Retry is rendered per bubble, so it has to resolve its own prompt from the rendered list rather
 * than from a remembered "last prompt". A stopped turn persists as a real chatEvent, so its Retry
 * button outlives later messages; anything keyed on recency replays the wrong prompt.
 *
 * Walks back rather than taking `index - 1` so it still resolves if anything ever sits between the
 * prompt and its reply. Returns null when there is no usable prompt above the bubble.
 */
export function findPromptForBubble(
  messages: readonly ChatMsgVM[],
  index: number
): ChatMsgVM | null {
  if (index < 0 || index >= messages.length) return null;
  for (let i = index - 1; i >= 0; i--) {
    const candidate = messages[i];
    if (candidate.author === 'user') return candidate.text ? candidate : null;
  }
  return null;
}
